import CreateVariantForm from "../../components/create/create-variant-form";

export default function CreateVariantPage() {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-12">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl max-xl:text-3xl font-bold bg-gradient-to-r from-[var(--color-primary-500)] to-[var(--color-primary-400)] bg-clip-text text-transparent mb-4">
            Create New Variant
          </h1>
          <p className="text-sm max-xl:text-sm text-gray-600 max-w-2xl mx-auto">
            Add a new variant option for your products. Define colors, sizes, materials, or any other attribute.
          </p>
        </div>

        {/* Form Container */}
        <div className="max-w-2xl mx-auto">
          <CreateVariantForm />
        </div>
      </div>
    </div>
  )
}
